import React, { useState } from 'react';
import Comments from '../components/Comments';
import '../css.css';

const OrderTimerNew = () => {
    const [fishData, setFishData] = useState([
        { id: 'fish1', name: '', freshness: 100, time: '', remain: '', intervalId: null },
        { id: 'fish2', name: '', freshness: 100, time: '', remain: '', intervalId: null },
        { id: 'fish3', name: '', freshness: 100, time: '', remain: '', intervalId: null },
        { id: 'fish4', name: '', freshness: 100, time: '', remain: '', intervalId: null }
    ]);

    const [orderData, setOrderData] = useState([
        { id: 'order1', name: '', gameHour: 0, gameMinutes: 0, realTime: '', intervalId: null },
        { id: 'order2', name: '', gameHour: 0, gameMinutes: 0, realTime: '', intervalId: null },
        { id: 'order3', name: '', gameHour: 0, gameMinutes: 0, realTime: '', intervalId: null },
        { id: 'order4', name: '', gameHour: 0, gameMinutes: 0, realTime: '', intervalId: null }
    ]);

    const [alarmFile, setAlarmFile] = useState('/sound/DoorBell10.mp3');
    const [alarmVolume, setAlarmVolume] = useState(0.1);

    const handleInputChange = (index, field, value, setState) => {
        setState((prevState) => {
            const newState = [...prevState];
            newState[index][field] = value;
            return newState;
        });
    };

    const handleAlarmFileChange = (e) => {
        setAlarmFile(e.target.value);
    };

    const handleAlarmVolumeChange = (e) => {
        setAlarmVolume(e.target.value);
    };

    const playAlarm = () => {
        const audio = new Audio(alarmFile);
        audio.volume = alarmVolume;
        audio.play();
    };

    const handleApplyFish = (index) => {
        const newFishData = [...fishData];
        const freshness = document.getElementById(`fish${index + 1}_freshness`).value;
        newFishData[index].freshness = freshness;
        const spoilTime = new Date(Date.now() + freshness * 14.4 * 60 * 1000);
        const totalMinutes = freshness * 14.4;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = Math.floor(totalMinutes % 60);
        newFishData[index].time = spoilTime.toLocaleTimeString();
        newFishData[index].remain = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;

        if (newFishData[index].intervalId) {
            clearInterval(newFishData[index].intervalId);
        }

        const intervalId = setInterval(() => {
            setFishData((prevFishData) => {
                const updatedFishData = [...prevFishData];
                if (updatedFishData[index].freshness > 0) {
                    const newFreshness = updatedFishData[index].freshness - 1;
                    if (newFreshness <= 0) {
                        clearInterval(updatedFishData[index].intervalId);
                    }
                    const totalMinutes = newFreshness * 14.4;
                    const hours = Math.floor(totalMinutes / 60);
                    const minutes = Math.floor(totalMinutes % 60);
                    const newRemain = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
                    updatedFishData[index] = {
                        ...updatedFishData[index],
                        freshness: newFreshness,
                        remain: newRemain
                    };
                    if (totalMinutes <= 30) {
                        playAlarm();
                    }
                }
                return updatedFishData;
            });
        }, 14.4 * 60 * 1000);

        newFishData[index].intervalId = intervalId;
        setFishData(newFishData);
    };

    const handleApplyOrder = (index) => {
        const newOrderData = [...orderData];
        const gameHour = parseInt(document.getElementById(`order${index + 1}_gameHour`).value, 10);
        const gameMinutes = parseInt(document.getElementById(`order${index + 1}_gameMinutes`).value, 10);
        newOrderData[index].gameHour = gameHour;
        newOrderData[index].gameMinutes = gameMinutes;
        const totalGameMinutes = gameHour * 60 + gameMinutes;
        const realMinutes = totalGameMinutes / 24;
        const realHours = Math.floor(realMinutes / 60);
        const realRemainingMinutes = Math.floor(realMinutes % 60);
        newOrderData[index].realTime = `${realHours}:${realRemainingMinutes < 10 ? '0' : ''}${realRemainingMinutes}`;

        if (newOrderData[index].intervalId) {
            clearInterval(newOrderData[index].intervalId);
        }

        const intervalId = setInterval(() => {
            setOrderData((prevOrderData) => {
                const updatedOrderData = [...prevOrderData];
                if (updatedOrderData[index].gameHour === 0 && updatedOrderData[index].gameMinutes <= 0) {
                    clearInterval(updatedOrderData[index].intervalId);
                    return updatedOrderData;
                }
                const totalGameMinutes = updatedOrderData[index].gameHour * 60 + updatedOrderData[index].gameMinutes - 24;
                const newGameHour = Math.floor(totalGameMinutes / 60);
                const newGameMinutes = totalGameMinutes % 60;
                if (newGameHour <= 0 && newGameMinutes <= 0) {
                    clearInterval(updatedOrderData[index].intervalId);
                }
                const realMinutes = totalGameMinutes / 24;
                const RealHour = Math.floor(realMinutes / 60);
                const realRemainingMinutes = Math.floor(realMinutes % 60);
                const newRealTime = `${RealHour}:${realRemainingMinutes < 10 ? '0' : ''}${realRemainingMinutes}`;
                updatedOrderData[index] = {
                    ...updatedOrderData[index],
                    gameHour: newGameHour,
                    gameMinutes: newGameMinutes,
                    realTime: newRealTime
                };
                if (realMinutes <= 30) {
                    playAlarm();
                }
                return updatedOrderData;
            });
        }, 60 * 1000);

        newOrderData[index].intervalId = intervalId;
        setOrderData(newOrderData);
    };

    return (
        <>
        <h1 className="page-title">오더 & 어망 타이머</h1>
        <div className="page-content">
            <div className='page-info'>
                <p>오더 및 어망 알림 타이머입니다.</p>
                <p>어종명 입력칸은 메모 용도로 사용하시면 됩니다.</p>
                <p>신선도 혹은 카페오더 인게임 남은시간을 입력하고 적용을 누르시면 현실 시간으로 계산이 됩니다.</p>
                <p>30분 이하가 남으면 알림을 재생합니다.</p>
                <p>알림음과 알림 크기는 하단에서 설정 가능합니다</p>
            </div>
            
            <div className="lure-categories">
                <div className="lure-category-section">
                    <h2 className="category-title">어망 신선도</h2>
                    <div className="table-container">
                        <table className="tacklexp-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>어종명</th>
                                    <th>신선도</th>
                                    <th>썩는시각</th>
                                    <th>잔여시간</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fishData.map((fish, index) => (
                                    <tr key={fish.id}>
                                        <td>
                                            <button className="ordertimer-apply-button" onClick={() => handleApplyFish(index)}>적용</button>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                value={fish.name}
                                                className='fishtimer-memo'
                                                onChange={(e) => handleInputChange(index, 'name', e.target.value, setFishData)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                id={`fish${index + 1}_freshness`}
                                                type="number"
                                                min="0"
                                                max="100"
                                                value={fish.freshness}
                                                className="ordertimer-input"
                                                onChange={(e) => handleInputChange(index, 'freshness', e.target.value, setFishData)}
                                            />
                                        </td>
                                        <td>{fish.time}</td>
                                        <td>{fish.remain}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div className="lure-category-section">
                    <h2 className="category-title">카페 오더</h2>
                    <div className="table-container">
                        <table className="tacklexp-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>어종명</th>
                        <th>인게임 시간</th>
                        <th>현실 시간</th>
                    </tr>
                </thead>
                <tbody>
                    {orderData.map((order, index) => (
                        <tr key={order.id}>
                            <td>
                                <button className="ordertimer-apply-button" onClick={() => handleApplyOrder(index)}>적용</button>
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className='ordertimer-memo'
                                    value={order.name}
                                    onChange={(e) => handleInputChange(index, 'name', e.target.value, setOrderData)}
                                />
                            </td>
                            <td>
                                <input
                                    id={`order${index + 1}_gameHour`}
                                    className="ordertimer-input"
                                    type="number"
                                    min="0"
                                    max="23"
                                    value={order.gameHour}
                                    onChange={(e) => handleInputChange(index, 'gameHour', e.target.value, setOrderData)}
                                />
                                :
                                <input
                                    id={`order${index + 1}_gameMinutes`}
                                    className="ordertimer-input"
                                    type="number"
                                    min="0"
                                    max="59"
                                    value={order.gameMinutes}
                                    onChange={(e) => handleInputChange(index, 'gameMinutes', e.target.value, setOrderData)}
                                />
                            </td>
                            <td>{order.realTime}</td>
                        </tr>
                    ))}
                </tbody>
                        </table>
                    </div>
                </div>
                
                <div className="lure-category-section">
                    <h2 className="category-title">알람 설정</h2>
                    <div className='ordertimer-alarm-setting'>
                <div className="ordertimer-alarm-setting-item">
                    <label htmlFor="alarmFile">알람 파일:</label>
                    <select id="alarmFile" value={alarmFile} onChange={handleAlarmFileChange} className="ordertimer-select">
                        <option value="/sound/DoorBell10.mp3">DoorBell 1</option>
                        <option value="/sound/DoorBell5.mp3">DoorBell 2</option>
                        <option value="/sound/elevator6.mp3">Elevator</option>
                        <option value="/sound/Fanfare11.mp3">Fanfare</option>
                    </select>
                </div>
                <div className="ordertimer-alarm-setting-item">
                    <label htmlFor="alarmVolume">알람 볼륨:</label>
                    <input
                        id="alarmVolume"
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={alarmVolume}
                        onChange={handleAlarmVolumeChange}
                        className="ordertimer-range"
                    />
                </div>
                <div className="ordertimer-alarm-setting-item">
                    <button
                        className="ordertimer-apply-button"
                        type="button"
                        onClick={playAlarm}
                    >
                        알람 테스트
                    </button>
                </div>
            </div>
        </div>
            </div>
        </div>
        
        <Comments pageName="ordertimer" />
        </>
    );
};

export default OrderTimerNew;